import { Observable, Subject } from 'rxjs';

export class CwLoaderService {
    protected changeStateTopic = new Subject<number>();
    private _counter = 0;

    public start(): void {
        this.counter++;
    }

    public finish(): void {
        this.counter--;
    }

    get changeState$(): Observable<number> {
        return this.changeStateTopic.asObservable();
    }

    get counter(): number {
        return this._counter;
    }

    set counter(value: number) {
        if (value < 0) {
            return;
        }

        this._counter = value;
        this.changeStateTopic.next(this._counter);
    }
}
